/**
 * Aggressive Recharge Fix - Directly overrides Recharge to ensure correct variant selection
 * This script takes a more direct approach to prevent Recharge from interfering
 */

(function() {
  'use strict';
  
  console.log('Aggressive Recharge Fix: Starting');
  
  // Store the correct variant ID globally
  let correctVariantId = null;
  
  // Monitor variant selection and store the correct ID
  document.addEventListener('change', function(event) {
    if (event.target.closest('variant-picker')) {
      const selectedOption = event.target;
      if (selectedOption.dataset.variantId) {
        correctVariantId = selectedOption.dataset.variantId;
        console.log('Aggressive Fix: Stored correct variant ID:', correctVariantId);
      }
    }
  });
  
  // Override ALL possible Recharge functions
  function overrideRechargeFunctions() {
    console.log('Aggressive Fix: Overriding Recharge functions...');
    
    // Override Recharge's global cart functions
    if (window.Recharge) {
      // Override Recharge.Cart.updateCart
      if (window.Recharge.Cart && window.Recharge.Cart.updateCart) {
        const originalUpdateCart = window.Recharge.Cart.updateCart;
        window.Recharge.Cart.updateCart = function(data, callback) {
          console.log('Aggressive Fix: Intercepting Recharge.Cart.updateCart');
          console.log('Original data:', data);
          
          if (data && data.items && data.items.length > 0 && correctVariantId) {
          console.log('Aggressive Fix: Forcing variant ID to:', correctVariantId);
            data.items[0].variant_id = correctVariantId;
            data.items[0].id = correctVariantId;
          }
          
          console.log('Updated data:', data);
          return originalUpdateCart.call(this, data, callback);
        };
      }
      
      // Override Recharge.cart.addToCart
      if (window.Recharge.cart && window.Recharge.cart.addToCart) {
        const originalAddToCart = window.Recharge.cart.addToCart;
        window.Recharge.cart.addToCart = function(variantId, quantity, properties) {
          console.log('Aggressive Fix: Intercepting Recharge.cart.addToCart');
          console.log('Aggressive Fix: original variant ID:', variantId);
          
          if (correctVariantId) {
            console.log('Aggressive Fix: Using correct variant ID:', correctVariantId);
            variantId = correctVariantId;
          }
          
          return originalAddToCart.call(this, variantId, quantity, properties);
        };
      }
      
      // Override any other Recharge cart methods
      if (window.Recharge.cart) {
        Object.keys(window.Recharge.cart).forEach(function(key) {
          if (typeof window.Recharge.cart[key] === 'function' && key.includes('add') || key.includes('cart')) {
            const originalMethod = window.Recharge.cart[key];
            window.Recharge.cart[key] = function(...args) {
            console.log('Aggressive Fix: Intercepting Recharge.cart.' + key);
              
              // If the first argument looks like a variant ID, replace it
              if (args.length > 0 && typeof args[0] === 'string' && correctVariantId) {
                console.log('Aggressive Fix: Replacing variant ID in', key);
                args[0] = correctVariantId;
              }
              
              return originalMethod.apply(this, args);
            };
          }
        });
      }
    }
    
    // Override any global cart functions that might be Recharge-related
    if (window.addToCart) {
      const originalAddToCart = window.addToCart;
      window.addToCart = function(variantId, quantity, properties) {
      console.log('Aggressive Fix: Intercepting global addToCart');
        
        if (correctVariantId) {
          console.log('Aggressive Fix: Using correct variant ID in global addToCart');
          variantId = correctVariantId;
        }
        
        return originalAddToCart.call(this, variantId, quantity, properties);
      };
    }
  }
  
  // Override fetch and XMLHttpRequest to intercept all cart requests
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    if (url && url.includes('/cart/add')) {
      console.log('Aggressive Fix: Intercepting fetch to /cart/add');
      
      if (options && options.body instanceof FormData) {
        const formData = options.body;
        const currentVariantId = formData.get('id');
        
        console.log('Aggressive Fix: current variant ID in request:', currentVariantId);
        console.log('Aggressive Fix: correct variant ID:', correctVariantId);
        
        if (correctVariantId && currentVariantId !== correctVariantId) {
          console.log('Aggressive Fix: Updating fetch request variant ID');
          formData.set('id', correctVariantId);
        }
      }
    }
    
    return originalFetch.call(this, url, options);
  };
  
  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;
  
  XMLHttpRequest.prototype.open = function(method, url, ...args) {
    this._url = url;
    return originalXHROpen.call(this, method, url, ...args);
  };
  
  XMLHttpRequest.prototype.send = function(data) {
    if (this._url && this._url.includes('/cart/add')) {
      console.log('Aggressive Fix: Intercepting XHR to /cart/add');
      
      if (data instanceof FormData) {
        const currentVariantId = data.get('id');
        
        console.log('Aggressive Fix: XHR current variant ID:', currentVariantId);
        console.log('Aggressive Fix: XHR correct variant ID:', correctVariantId);
        
        if (correctVariantId && currentVariantId !== correctVariantId) {
          console.log('Aggressive Fix: Updating XHR request variant ID');
          data.set('id', correctVariantId);
        }
      }
    }
    
    return originalXHRSend.call(this, data);
  };
  
  // Wait for Recharge to load and then apply overrides
  function waitForRecharge() {
    if (window.Recharge) {
      console.log('Aggressive Fix: Recharge detected, applying overrides');
      overrideRechargeFunctions();
    } else {
      setTimeout(waitForRecharge, 100);
    }
  }
  
  // Also try to override immediately in case Recharge is already loaded
  overrideRechargeFunctions();
  
  // Start monitoring
  waitForRecharge();
  
  // Monitor for any new Recharge functions that might be added dynamically
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        // Check if Recharge was added to the page
        if (window.Recharge && !window._rechargeOverridden) {
          console.log('🚨 Aggressive Fix: Recharge detected dynamically, applying overrides');
          overrideRechargeFunctions();
          window._rechargeOverridden = true;
        }
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  console.log('Aggressive Recharge Fix: Initialized');
  
})();
